import type { MultiValueProps, OptionTypeBase } from 'react-select';

import { TagLabel, type TagLabelProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';

export interface MultiValueLabelProps<OptionType extends OptionTypeBase>
  extends MultiValueProps<OptionType> {
  innerProps: TagLabelProps;
}

export const MultiValueLabel = <OptionType extends OptionTypeBase>({
  children,
  innerProps,
}: MultiValueLabelProps<OptionType>) => {
  const styles = useSelectStyles();

  return (
    <TagLabel {...innerProps} __css={styles.multiValueLabel}>
      {children}
    </TagLabel>
  );
};
